import React from 'react';

import { ButtonProps as MuiButtonProps } from '@mui/material/Button/Button';
import constants from 'constants/constants';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { CustomizedTooltip } from 'components/common';

interface Props {
    icon: string;
    onClick?: MuiButtonProps['onClick'];
    tooltipContent?: React.ReactNode;
    useCustomIcon?: boolean;
    type?: 'outlined' | 'round' | 'sharp';
}
export const WidgetButton = ({ icon, onClick, tooltipContent, useCustomIcon = false, type }: Props) => {
    return (
        <CustomizedTooltip
            key={'tableColumns'}
            tooltipPosition={TooltipPosition.Top}
            tooltipContent={tooltipContent}
            disabled={!tooltipContent}
            triggerElement={
                <Button variant={'tertiary'} onClick={onClick}>
                    {useCustomIcon ? (
                        <Icon fontSize={constants.WIDGET_ICON_SIZE} name={icon} color={'var(--button-tertiary-fg)'} />
                    ) : (
                        <MuiIcon
                            fontSize={constants.WIDGET_ICON_SIZE}
                            icon={icon}
                            color={'var(--button-tertiary-fg)'}
                            type={type}
                        />
                    )}
                </Button>
            }
        />
    );
};
